import { useState, useEffect, useCallback } from 'react';
import { DISCOUNT } from '../constants/index';
import { useSelector, useDispatch } from 'react-redux';
import { useGlobal, useBusinessType, useDaybook, useAccount, useItem } from '../contexts';
import { getSingleItem } from "../redux/actions/item"

const useCalculateTaxAmount = ({ row, setRow, setBillTerms, invoiceType }) => {
   const [totalBillTermAmount, setTotalBillTermAmount] = useState(0);
   const [billTerm, setBillTerm] = useState(0);
   const [totalTaxableAmount, setTotalTaxableAmount] = useState(0);
   const [finalNetAmount, setFinalNetAmount] = useState(0);
   const [totals, setTotals] = useState({
      qty1: 0,
      qty2: 0,
      qty3: 0,
      basicAmount: 0,
      discount1: 0,
      discount2: 0,
      discount3: 0,
      netAmount: 0,
      taxAmount: 0,
      gstAmount: 0,
      taxableAmount: 0,
      netGstAmount: 0,
   });

   const { company } = useGlobal();
   const { businessTypes } = useBusinessType();
   const dispatch = useDispatch();

   // const itemData = useSelector((state) => state.item?.list);
   const billTermData = useSelector((state) => state.billTerm?.list);
   const { daybooks } = useDaybook();
   const { accounts } = useAccount();
   const { items: itemData } = useItem();
   // const daybookData = useSelector((state) => state.daybook?.allDaybooks);
   // const daybookData = daybooks;

   const totalsAmount = useCallback(() => {
      const lineItem = row.lineItem?.filter((x) => x.isDeleted === false) ?? [];
      setTotals({
         qty1: lineItem.reduce((acc, item) => acc + Number(item?.qty1), 0),
         qty2: lineItem.reduce((acc, item) => acc + Number(item?.qty2), 0),
         qty3: lineItem.reduce((acc, item) => acc + Number(item?.qty3), 0),
         basicAmount: lineItem.reduce((acc, item) => {
            return acc + Number(item?.amount || 0);
         }, 0),
         discount1: lineItem.reduce((acc, item) => acc + Number(item?.addLess1Amount || 0), 0),
         discount2: lineItem.reduce((acc, item) => acc + Number(item?.addLess2Amount || 0), 0),
         discount3: lineItem.reduce((acc, item) => acc + Number(item?.addLess3Amount || 0), 0),
         netAmount: lineItem.reduce((acc, item) => {
            return acc + Number(item?.netAmount || 0);
         }, 0),
         taxAmount: lineItem.reduce((acc, item) => acc + Number(item?.taxAmount || 0), 0),
         gstAmount: lineItem.reduce((acc, item) => acc + Number(item?.gstAmount || 0), 0),
         netGstAmount: lineItem.reduce((acc, item) => acc + Number(item?.netGst || 0), 0),
         taxableAmount: lineItem.reduce((acc, item) => acc + Number(item?.taxableAmount || 0), 0),
      });
      const finalAmount = totals.taxableAmount + totals.netGstAmount;
      setFinalNetAmount(finalAmount);
   }, [row.lineItem, totals.netGstAmount, totals.taxableAmount]);

   const handleQtyChange = useCallback(
      (name, value, index) => {
         const newRow = { ...row };
         if (!newRow.lineItem[index]) newRow.lineItem[index] = {};

         const selectedItem = itemData.find((item) => item.id === newRow.lineItem[index]?.itemId);

         if (name === 'qty1' && newRow.lineItem[index]?.unit === selectedItem?.uqc1Data?.id) {
            const amount = newRow.lineItem[index].itemRate * Number(value || 0);
            newRow.lineItem[index].amount = amount;
            newRow.lineItem[index].netAmount = amount;
         }
         if (name === 'qty2' && newRow.lineItem[index]?.unit === selectedItem?.uqc2Data?.id) {
            const amount = newRow.lineItem[index].itemRate * Number(value || 0);
            newRow.lineItem[index].amount = amount;
            newRow.lineItem[index].netAmount = amount;
         }
         if (name === 'qty3' && newRow.lineItem[index]?.unit === selectedItem?.uqc3Data?.id) {
            const amount = newRow.lineItem[index].itemRate * Number(value || 0);
            newRow.lineItem[index].amount = amount;
            newRow.lineItem[index].netAmount = amount;
         }
         newRow.lineItem[index][name] = Number(value || 0);

         totalsAmount();
         setRow(newRow);
         // handleBillTerm()
      },
      [row, setRow, totalsAmount],
   );

   const handleItemAndReteChange = useCallback(
      (index) => {
         const newRow = { ...row };
         if (!newRow.lineItem[index]) newRow.lineItem[index] = {};
         // newRow.lineItem[index][name] = Number(value || 0);
         newRow.lineItem[index].amount = newRow.lineItem[index].qty1 * newRow.lineItem[index].itemRate;
         newRow.lineItem[index].netAmount = newRow.lineItem[index].amount;
         totalsAmount();
         setRow(newRow);
      },
      [row, setRow],
   );

   const handleRateChange = useCallback(
      (name, value, index) => {
         const newRow = { ...row };
         newRow.lineItem[index][name] = Number(value || 0);

         const selectedItem = itemData.find((item) => item.id === newRow.lineItem[index]?.itemId);
         const unit = newRow.lineItem[index].unit;

         let qty =
            unit === selectedItem?.uqc1Data?.id
               ? newRow.lineItem[index].qty1
               : unit === selectedItem?.uqc2Data?.id
                  ? newRow.lineItem[index].qty2
                  : unit === selectedItem?.uqc3Data?.id
                     ? newRow.lineItem[index].qty3
                     : newRow.lineItem[index].qty1;

         const amount = qty * Number(value);

         newRow.lineItem[index].amount = amount;
         newRow.lineItem[index].netAmount = amount;
         totalsAmount();
         setRow(newRow);
      },
      [row, setRow],
   );

   const handleDiscountChange = useCallback(
      (name, value, index) => {
         const newRow = { ...row };
         newRow.lineItem[index][name] = Number(value || 0);
         if (name === DISCOUNT.DISCOUNT_PERCENT1) {
            newRow.lineItem[index].addLess1Amount = (newRow.lineItem[index].amount * Number(value || 0)) / 100;

            // newRow.lineItem[index].newAmount =
            //   newRow.lineItem[index].amount - newRow.lineItem[index].addLess1Amount;
         }
         if (name === DISCOUNT.DISCOUNT_PERCENT2) {
            newRow.lineItem[index].addLess2Amount =
               ((newRow.lineItem[index].amount - newRow.lineItem[index].addLess1Amount) * Number(value || 0)) / 100;
         }
         if (name === DISCOUNT.DISCOUNT_PERCENT3) {
            newRow.lineItem[index].addLess3Amount =
               ((newRow.lineItem[index].amount -
                  newRow.lineItem[index].addLess1Amount -
                  newRow.lineItem[index].addLess2Amount) *
                  Number(value || 0)) /
               100;
         }

         let netAmount = newRow.lineItem[index].amount - newRow.lineItem[index].addLess1Amount;
         netAmount = netAmount - newRow.lineItem[index].addLess2Amount;
         netAmount = netAmount - newRow.lineItem[index].addLess3Amount;
         newRow.lineItem[index].netAmount = netAmount;
         totalsAmount();
         setRow(newRow);
      },
      [row, setRow],
   );

   const handleBillTermChange = useCallback(
      (name, value, index) => {
         const newRow = { ...row };
         newRow.billTerm[index][name] = value;
         totalsAmount();
         setRow(newRow);
      },
      [row, setRow],
   );

   const handleItemChange = useCallback(
      async (name, value, index, type) => {
         const newRow = { ...row };
         let selectedItem = itemData?.find((item) => item?.id === value);
         if (selectedItem === undefined) {
            const res = await dispatch(getSingleItem(value))
            selectedItem = res
         }

         newRow.lineItem[index].salesprice1 = invoiceType === "sales" ? selectedItem?.salesprice1 : invoiceType === "purchase" ? selectedItem?.purchaseprice : 0;
         newRow.lineItem[index].itemRate = invoiceType === "sales" ? selectedItem?.salesprice1 : invoiceType === "purchase" ? selectedItem?.purchaseprice : 0;
         newRow.lineItem[index].hsnData = selectedItem?.hsnData;
         newRow.lineItem[index].sacData = selectedItem?.sacData;

         newRow.lineItem[index].gst = 0;
         newRow.lineItem[index].netGst = 0;
         newRow.lineItem[index].gstAmount = 0;
         newRow.lineItem[index].taxableAmount = 0;

         newRow.lineItem[index][name] = Number(value);
         const lineItem = newRow.lineItem[index];

         const daybook = daybooks.find((a) => a.id.toString() === row?.header?.daybookId.toString());
         const selectedAccount = accounts.find((item) => item.id.toString() === row?.header?.accountId.toString());
         if (company?.setting?.applyGST && daybook?.applyGst && !['issue', 'receive', 'purchaseorder', 'salesorder'].includes(invoiceType)) {
            let hsn;
            if (lineItem?.typeOfSupply === 1) {
               if (selectedItem?.hsnData?.subHsn.length === 1) {
                  hsn = selectedItem?.hsnData?.subHsn[0];
               } else {
                  hsn = selectedItem?.hsnData?.subHsn.find(
                     (hsn) => lineItem.itemRate >= hsn.fromRate && lineItem.itemRate <= hsn.toRate,
                  );
               }
            }

            if (lineItem?.typeOfSupply === 2) {
               if (selectedItem?.sacData?.subHsn.length === 1) {
                  hsn = selectedItem?.sacData?.subHsn[0];
               } else {
                  hsn = selectedItem?.sacData?.subHsn.find(
                     (hsn) => lineItem.itemRate >= hsn.fromRate && lineItem.itemRate <= hsn.toRate,
                  );
               }
            }
            const newGSt = type === "purchaseinvoice" || type === "purchasereturn" ? selectedAccount?.gstRegNo ? Number(hsn?.gst) : 0 : Number(hsn?.gst);
            newRow.lineItem[index].gst = newGSt ?? 0;
            newRow.lineItem[index].subHSNId = hsn?.id ?? null;
            newRow.lineItem[index].gstAmount = lineItem.itemRate * lineItem.qty1 * (newGSt / 100);
            newRow.lineItem[index].ratio = hsn?.ratio ?? null;
         }
         totalsAmount();
         setRow(newRow);
         return;
      },
      [company?.setting?.applyGST, daybooks, itemData, row, setRow, totalsAmount],
   );

   const handleUnitChange = useCallback(
      (value, idx) => {
         const newRow = { ...row };
         newRow.lineItem[idx].unit = value;

         const selectedItem = itemData.find((item) => item.id === newRow.lineItem[idx]?.itemId);

         let qty =
            value === selectedItem?.uqc1Data?.id
               ? newRow.lineItem[idx].qty1
               : value === selectedItem?.uqc2Data?.id
                  ? newRow.lineItem[idx].qty2
                  : value === selectedItem?.uqc3Data?.id
                     ? newRow.lineItem[idx].qty3
                     : newRow.lineItem[idx].qty1;

         newRow.lineItem[idx].amount = qty * newRow.lineItem[idx].itemRate;

         newRow.lineItem[idx].netAmount = newRow.lineItem[idx].amount;
         setRow(newRow);
      },
      [row, setRow],
   );

   useEffect(() => {
      totalsAmount();
   }, [totalsAmount]);

   useEffect(() => {
      setTotalTaxableAmount(totals.netAmount + Number(billTerm));
   }, [billTerm, totals.netAmount]);

   useEffect(() => {
      const newRows = { ...row };
      newRows.lineItem = row.lineItem.map((item) => {
         const taxableAmount = (totalTaxableAmount * item.netAmount) / totals.netAmount;
         const netGst = (taxableAmount * item.gst) / 100;
         return {
            ...item,
            taxableAmount: taxableAmount,
            netGst: netGst,
            gstAmount: netGst + taxableAmount,
         };
      });
      setRow(newRows);
   }, [setRow, totalTaxableAmount, totals.netAmount]);

   useEffect(() => {
      const netAmount = parseFloat(totals.netAmount) || 0;

      setBillTerms((prevBillTerm) => {
         let additionTotal = 0;
         let deductionTotal = 0;
         const newBillTerms = prevBillTerm.map((term, idx) => {
            const billTermMaster = billTermData.find((b) => b.id === term.billTermId);
            const calculatedAmount = (netAmount * parseFloat(term.percentage)) / 100;

            const findAmount =
               billTermMaster && billTermMaster.signname === 'Subtraction'
                  ? -Math.abs(calculatedAmount)
                  : billTermMaster && billTermMaster.signname === 'Addition'
                     ? Math.abs(calculatedAmount)
                     : calculatedAmount;

            if (billTermMaster?.signname === 'Subtraction') {
               deductionTotal += Math.abs(findAmount);
            } else if (billTermMaster?.signname === 'Addition') {
               additionTotal += Math.abs(findAmount);
            } else if (billTermMaster?.signname === 'Both') {
               if (findAmount < 0) {
                  deductionTotal += Math.abs(findAmount);
               } else {
                  additionTotal += findAmount;
               }
            }

            return {
               ...term,
               amount: findAmount,
               percentage: term.percentage,
               billTermId: term.billTermId,
            };
         });

         let billTerm = additionTotal - deductionTotal;
         let netTotal = totals.netAmount + additionTotal;
         netTotal = netTotal - deductionTotal;
         setBillTerm(billTerm);
         setTotalBillTermAmount(netTotal);

         return newBillTerms;
      });
   }, [billTermData, setBillTerms, totals.netAmount]);

   useEffect(() => {
      setFinalNetAmount(totals.taxableAmount + totals.netGstAmount)
      return () => { }
   }, [totals.taxableAmount, totals.netGstAmount])


   return {
      handleQtyChange,
      handleRateChange,
      handleDiscountChange,
      handleBillTermChange,
      totals,
      setTotalBillTermAmount,
      totalBillTermAmount,
      totalTaxableAmount,
      setBillTerm,
      billTerm,
      finalNetAmount,
      handleItemChange,
      handleItemAndReteChange,
      setTotalTaxableAmount,
      handleUnitChange,
   };
};

export default useCalculateTaxAmount;
